var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPhone = function SvgIcPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e424c",
    fillRule: "evenodd",
    d: "M1.382 1A.382.382 0 0 0 1 1.382C1 8.903 7.097 15 14.618 15a.382.382 0 0 0 .382-.382v-4.074l-3.702-1.48-1.104 1.84a.5.5 0 0 1-.65.191 10.206 10.206 0 0 1-4.64-4.639.5.5 0 0 1 .192-.65l1.84-1.104L5.456 1zM0 1.382C0 .62.619 0 1.382 0h4.412a.5.5 0 0 1 .464.314l1.765 4.412a.5.5 0 0 1-.207.615L6.015 6.42a9.206 9.206 0 0 0 3.564 3.564l1.08-1.801a.5.5 0 0 1 .615-.207l4.412 1.765a.5.5 0 0 1 .314.464v4.412C16 15.38 15.381 16 14.618 16 6.545 16 0 9.455 0 1.382z",
    clipRule: "evenodd"
  })));
};
export default SvgIcPhone;